export const formatDateTime = (date) => {
    if (!date) {
        return null;
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    var hour = '' + d.getHours(),
        minute = '' + d.getMinutes();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (hour.length < 2)
        hour = '0' + hour;
    if (minute.length < 2)
        minute = '0' + minute;


    return [year, month, day].join('-') + 'T' + [hour, minute].join(':');
};

export const formatDateTimeWithSeconds = (date) => {
    if (!date) {
        return null;
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    var hour = '' + d.getHours(),
        minute = '' + d.getMinutes(),
        second = '' + d.getSeconds();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (hour.length < 2)
        hour = '0' + hour;
    if (minute.length < 2)
        minute = '0' + minute;
    if (second.length < 2)
        second = '0' + second;


    return [year, month, day].join('-') + 'T' + [hour, minute, second].join(':');
};

export const formatDate = (date) => {
    if (!date) {
        return null;
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
/*     if (hour.length < 2)
        hour = '0' + hour;
    if (minute.length < 2)
        minute = '0' + minute; */


    return [year, month, day].join('-');
};

export const formatTime = (date) => {
    if (!date) {
        return null;
    }
    var d = new Date(date),
        hour = '' + d.getHours(),
        minute = '' + d.getMinutes();


    if (hour.length < 2)
        hour = '0' + hour;
    if (minute.length < 2)
        minute = '0' + minute;


    return [hour, minute].join(':');
};

const dateFormatTimeSeconds = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'Europe/Berlin',
});
const dateFormatTime = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Berlin',
});
const dateFormat = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'Europe/Berlin',
});

/**
 * Formats date as yyyy.mm.dd
 * @param {*} value Date String
 * @returns Formatted date
 */
export function formatDateView(value) {
    const date = new Date(value);
    return dateFormat.format(date);
};
/**
 * Formats date as yyyy.mm.dd, hh:mm
 * @param {*} value Date String
 * @returns Formatted date
 */
export function formatDateTimeView(value) {
    const date = new Date(value);
    return dateFormatTime.format(date);
};
/**
 * Formats date as yyyy.mm.dd, hh:mm:ss
 * @param {*} value Date String
 * @returns Formatted date
 */
export function formatDateTimeSecondsView(value) {
    const date = new Date(value);
    return dateFormatTimeSeconds.format(date);
};

export default { formatDateTime, formatTime, formatDate }
